import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GmMyRewardsCustomerInformationComponent } from './gm-my-rewards-customer-information/gm-my-rewards-customer-information.component';
import { GmMyRewardsVerifyAccountDialogComponent } from './gm-my-rewards-verify-account-dialog/gm-my-rewards-verify-account-dialog.component';
import { GmMyRewardsOffersComponent } from './gm-my-rewards-offers/gm-my-rewards-offers.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonPipesModule } from '@quorum/common-pipes';
import { TextMaskModule } from 'angular2-text-mask';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  imports: [
    CommonModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    CommonPipesModule,
    TextMaskModule,
    MatDialogModule,
  ],
  declarations: [
    GmMyRewardsCustomerInformationComponent,
    GmMyRewardsVerifyAccountDialogComponent,
    GmMyRewardsOffersComponent,
  ],
  exports: [
    GmMyRewardsCustomerInformationComponent,
    GmMyRewardsVerifyAccountDialogComponent,
    GmMyRewardsOffersComponent,
  ],
})
export class GmMyRewardsModule {}
